export default __webpack_public_path__ + "static/media/snowflake.72f49c0a.png";